import type { SVGProps } from 'react';
const SvgPlusBackground = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#plus-background_svg__a)">
      <path
        fill="currentColor"
        d="M11.157 13.843v3.49q0 .332.256.587.255.256.587.256.33 0 .587-.256a.8.8 0 0 0 .256-.586v-3.491h3.49q.332 0 .587-.256a.8.8 0 0 0 .256-.587.8.8 0 0 0-.256-.587.8.8 0 0 0-.587-.255h-3.49V8.667a.8.8 0 0 0-.256-.587.8.8 0 0 0-.587-.256.8.8 0 0 0-.587.256.8.8 0 0 0-.256.587v3.49h-3.49a.8.8 0 0 0-.587.256.8.8 0 0 0-.256.587q0 .33.256.587.255.255.587.256zm-5.176 5.176a8.3 8.3 0 0 1-1.873-2.822A8.6 8.6 0 0 1 3.484 13q0-1.625.624-3.197a8.3 8.3 0 0 1 1.873-2.821 8.3 8.3 0 0 1 2.822-1.873A8.6 8.6 0 0 1 12 4.484q1.623 0 3.197.625a8.3 8.3 0 0 1 2.822 1.873 8.3 8.3 0 0 1 1.873 2.821A8.6 8.6 0 0 1 20.516 13a8.6 8.6 0 0 1-.624 3.198 8.2 8.2 0 0 1-1.873 2.82 8.35 8.35 0 0 1-2.822 1.874 8.5 8.5 0 0 1-3.197.625 8.7 8.7 0 0 1-3.198-.625 8.25 8.25 0 0 1-2.82-1.873"
      />
    </g>
    <defs>
      <clipPath id="plus-background_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPlusBackground;
